import {
  TbCircleDashedNumber0,
  TbCircleDashedNumber1,
  TbCircleDashedNumber2,
  TbCircleDashedNumber3,
  TbCircleDashedNumber4,
  TbCircleDashedNumber5,
  TbCircleDashedNumber6,
  TbCircleDashedNumber7,
  TbCircleDashedNumber8,
  TbCircleDashedNumber9
} from 'react-icons/tb'

export enum ReceiverCurrentAz {
  unknown = 'unknown'
}

export const pathNoIcons = [
  TbCircleDashedNumber1,
  TbCircleDashedNumber2,
  TbCircleDashedNumber3,
  TbCircleDashedNumber4,
  TbCircleDashedNumber5,
  TbCircleDashedNumber6,
  TbCircleDashedNumber7,
  TbCircleDashedNumber8,
  TbCircleDashedNumber9
]

export const getReceiverPathIcon = (index: number) => {
  if (index < pathNoIcons.length) {
    return pathNoIcons[index]
  }

  return TbCircleDashedNumber0
}

export const RECEIVERS_QUEUE_SIZE_OPTION_0 = {
  label: '>0',
  value: '>0'
}

export const RECEIVERS_QUEUE_SIZE_OPTION_5 = {
  label: '5+',
  value: '5+'
}

export const RECEIVERS_QUEUE_SIZE_OPTION_10 = {
  label: '10+',
  value: '10+'
}

export const RECEIVERS_QUEUE_SIZE_OPTIONS = [RECEIVERS_QUEUE_SIZE_OPTION_0, RECEIVERS_QUEUE_SIZE_OPTION_5, RECEIVERS_QUEUE_SIZE_OPTION_10]
